// System roles
export const SUPER_ADMIN_ROLE_ID = 1
export const INTERNAL_SYSTEM_ROLE_ID = 2
export const BUSINESS_ENTITY_SYSTEM_ROLE_ID = 3
export const RESOURCE_SYSTEM_ROLE_ID = 4
export const CLIENT_SYSTEM_ROLE_ID = 5

// Business entity roles
export const BUSINESS_ENTITY_ADMIN_ROLE_ID = 7
export const BUSINESS_ENTITY_USER_ROLE_ID = 8
export const BUSINESS_ENTITY_RESOURCE_ROLE_ID = 9
